import * as React from "react";
import { PaymentTypeConstants } from "../../../common/Constants";
import DomesticPaymentForm from "./DomesticPaymentForm";
import AbroadPaymentForm from "./AbroadPaymentForm";
import TransferPaymentForm from "./TransferPaymentForm";
import { TPaymentConfirmationPresentationModel } from "../../../presenter/payment/model/PaymentConfirmationPresentationModel";

const PaymentConfirmationDetails = ({
  paymentConfirmationData,
  translate
}: {
  paymentConfirmationData: TPaymentConfirmationPresentationModel;
  translate: any;
}) => {
  switch (paymentConfirmationData && paymentConfirmationData.type) {
    case PaymentTypeConstants.UPP:
      return (
        <DomesticPaymentForm
          paymentConfirmationData={paymentConfirmationData}
          translate={translate}
        />
      );

    case PaymentTypeConstants.INO:
      return (
        <AbroadPaymentForm
          paymentConfirmationData={paymentConfirmationData}
          translate={translate}
        />
      );
    case PaymentTypeConstants.TRANSFER:
      return (
        <TransferPaymentForm
          paymentConfirmationData={paymentConfirmationData}
          translate={translate}
        />
      );

    default:
      return <React.Fragment></React.Fragment>;
  }
};

export default PaymentConfirmationDetails;
